
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function HowItWorksSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const steps = [
    {
      number: 1,
      title: 'Mapeamento Estratégico',
      description: 'Analisamos seu negócio, público e processos para configurar a IA perfeitamente alinhada aos seus objetivos.',
      color: 'from-primary to-accent-cyan',
    },
    {
      number: 2,
      title: 'Configuração e Testes',
      description: 'Criamos o ambiente de testes, ajustamos respostas e validamos cada funcionalidade antes de ir ao ar.',
      color: 'from-secondary to-accent-purple',
    },
    {
      number: 3,
      title: 'Implantação no WhatsApp',
      description: 'Conectamos o sistema ao seu WhatsApp, Instagram e Messenger de forma segura e profissional.',
      color: 'from-primary to-accent-cyan',
    },
    {
      number: 4,
      title: 'Sistema Ativo',
      description: 'Sua IA começa a atender imediatamente. Você acompanha tudo pelo dashboard em tempo real.',
      color: 'from-secondary to-accent-purple',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-navy-dark to-dark">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6">
        <div 
          className={`text-center mb-12 sm:mb-20 transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            Como <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent-cyan">Funciona</span>
          </h2>
          <p className="text-sm sm:text-lg text-gray-400 max-w-2xl mx-auto px-2">
            Processo simples e rápido. Do mapeamento à implantação em poucos passos.
          </p>
        </div>

        <div className="relative">
          <div 
            className={`hidden md:block absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-secondary to-transparent transition-all duration-1000 ease-out ${
              isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
            }`}
            style={{ transitionDelay: '300ms' }}
          ></div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 relative">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className={`relative transition-all duration-700 ease-out ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${200 + index * 150}ms` }}
              >
                <div className="flex flex-col items-center mb-4 sm:mb-6">
                  <div className={`w-14 h-14 sm:w-20 sm:h-20 flex items-center justify-center rounded-full bg-gradient-to-r ${step.color} text-xl sm:text-3xl font-bold text-dark mb-3 sm:mb-4 relative z-10 transition-all duration-500 shadow-lg ${
                    isVisible ? 'scale-100' : 'scale-0'
                  }`}
                  style={{ transitionDelay: `${400 + index * 150}ms` }}
                  >
                    {step.number}
                  </div>
                </div>

                <div className="bg-dark-secondary rounded-lg sm:rounded-xl p-4 sm:p-6 border border-dark-border min-h-[200px] sm:min-h-[280px] flex flex-col hover:border-secondary/50 transition-colors">
                  <h3 className={`text-sm sm:text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r ${step.color} mb-2 sm:mb-3`}>{step.title}</h3>
                  <p className="text-gray-400 text-xs sm:text-sm leading-relaxed flex-grow">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div 
          className={`mt-8 sm:mt-12 text-center transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '800ms' }}
        >
          <div className="inline-block px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-primary/20 to-accent-cyan/20 text-primary font-bold rounded-full border border-primary/30 text-xs sm:text-base">
            ✓ Entrega no Mesmo Dia (após envio das informações)
          </div>
          <p className="mt-3 sm:mt-4 text-gray-400 text-xs sm:text-base px-4">
            <strong className="text-white">Implementação gratuita</strong> feita pelo CEO Rafael F. Silva
          </p>
        </div>
      </div>
    </section>
  );
}
